import KformElementController from '~/components/kform/element/kform-element.controller';

/* globals Knitiv */

export default class KformBuilderElementController extends KformElementController {
	/* @ngInject */
	/**
	 * @param {import('angular').ICompileService} $compile
	 * @param {import('angular').IRootElementService} $element
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ISCEService} $sce
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('~/components/kform/components/kform-components.provider').default} KformComponents
	 */
	constructor($compile, $element, $rootScope, $sce, $scope, $timeout, KformComponents) {
		super($compile, $element, $rootScope, $sce, $scope, $timeout);
		this.components = KformComponents.components;

		/** @type {any} */
		this.formComponent = undefined;
	}

	$onInit() {
		this.$scope.builder = true;
		this.$scope.component = this.component;
		this.$scope.componentId = this.component.key;
		this.formComponent = this.components[this.component.type] || this.components.custom;
		const rawTemplate = this.formComponent.fbtemplate ?? this.formComponent.template;

		if (rawTemplate) {
			const template = typeof rawTemplate === 'function'
				? rawTemplate(this.$scope)
				: rawTemplate;
			this.template = this.$sce.trustAsHtml(template);
		}
	}
}